module.exports = "<div style=\"display: flex;\">\n  <label class=\"btn btn-outline-primary btn-import ml-2\" [ladda]=\"isUploading\">Import\n    <input *ngIf=\"!isUploading\" type=\"file\" (change)=\"fileUpload($event)\">\n  </label>\n  <label *ngIf=\"publishInProcess !== ''\" style=\"color: green\" class=\"btn btn-outline-primary btn-import ml-2\" >{{ publishInProcess }}</label>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/import-button/import-button.component.html
// module id = ./src/app/components/import-button/import-button.component.html
// module chunks = main